export default "__VITE_ASSET__3b574057__"